// ============================================
// continents.js - 世界大洲数据管理
// ============================================

export const continents = [
  {
    id: 'asia',
    name: 'Asia',
    label: 'Asia',
    status: 'active',
    color: '#FF6B6B',
    description: 'Explore the diverse landscapes and cultures of Asia'
  },
  {
    id: 'northAmerica',
    name: 'North America',
    label: 'North America',
    status: 'active',
    color: '#4ECDC4',
    description: 'Discover the wonders of North America'
  },
  {
    id: 'southAmerica',
    name: 'South America',
    label: 'South America',
    status: 'coming-soon',
    color: '#95E1D3',
    description: 'Coming soon...'
  },
  {
    id: 'europe',
    name: 'Europe',
    label: 'Europe',
    status: 'active',
    color: '#FFE66D',
    description: 'Experience the charm and elegance of Europe'
  },
  {
    id: 'africa',
    name: 'Africa',
    label: 'Africa',
    status: 'coming-soon',
    color: '#A8DADC',
    description: 'Coming soon...'
  },
  {
    id: 'oceania',
    name: 'Oceania',
    label: 'Oceania',
    status: 'coming-soon',
    color: '#C9ADA7',
    description: 'Coming soon...'
  },
  {
    id: 'antarctica',
    name: 'Antarctica',
    label: 'Antarctica',
    status: 'coming-soon',
    color: '#9A8C98',
    description: 'Coming soon...'
  }
];